<!-- USE THIS TEMPLATE FOR THE ADDRESS STATUS INFO COMPONENTS -->
@defer (when !isLoading()) {
  @if (isTestMode()) {
    <div class="text-center mb-1" translate>status.TestModeLongDescriptionLine1</div>
    <div class="text-center mb-3" translate>status.TestModeLongDescriptionLine2</div>
  }

  @if (privateRecipientDetails?.length > 0 || companies?.length > 0) {
    <div class="tables-wrapper">
      <!-- PHONE NUMBERS -->
      @if (phoneRecipientsDetails?.length > 0) {
        <bi-address-info-table
          [recipientsDetails]="phoneRecipientsDetails"
          contactDetailIconClass="fa-solid fa-mobile-alt"
          [isStatus]="true"
          [useColumnWidthLimits]="alignTables()"
          recipientType="phone"
          [show3Columns]="true"
          @fadeIn
        />
      }

      <!-- EMAILS -->
      @if (emailRecipientsDetails?.length > 0) {
        <bi-address-info-table
          [recipientsDetails]="emailRecipientsDetails"
          contactDetailIconClass="fa-regular fa-envelope"
          [isStatus]="true"
          [useColumnWidthLimits]="alignTables()"
          recipientType="email"
          [show3Columns]="true"
          @fadeIn
        />
      }

      <!-- E-BOKS -->
      @if (eboksRecipientsDetails?.length > 0) {
        <bi-address-info-table [recipientsDetails]="eboksRecipientsDetails" [isStatus]="true" recipientType="eboks" [useColumnWidthLimits]="alignTables()" [show3Columns]="true" @fadeIn />
      }

      <!-- COMPANIES -->
      @if (companies?.length > 0) {
        <bi-address-info-table [recipientsDetails]="companies" recipientType="company" [useColumnWidthLimits]="alignTables()" [show3Columns]="true" @fadeIn />
      }
    </div>
  } @else {
    <!-- No info -->
    <p class="text-center" translate>shared.NoInfoFound</p>
  }
} @placeholder {
  <bi-spinner [centerInParent]="true" @fadeIn />
}
